/* eslint-disable no-restricted-globals */
import moment from 'moment';
import { ABROAD, DOMESTIC } from '../constants/variables';
import { withNamespaces } from 'react-i18next';
import i18n from "i18next";

export default function (request, index, totalIndex) {
  index += 1;

  if (!request.travelStartDate || !request.travelEndDate) {
    return { result: true };
  }

  const travelStartDate = moment(request.travelStartDate);
  const travelStartDateunixTimeToDate = travelStartDate
    .format('YYYY-MM-DD');


  const travelEndDate = moment(request.travelEndDate);


  const travelEndDateunixTimeToDate = travelEndDate
    .format('YYYY-MM-DD');


  const differenceOfDates = travelEndDate.diff(travelStartDate, 'days');


  const isPublicDay = request.publicHolidays && request.publicHolidays.some(holiday => holiday === request.travelStartDate);


  const isSunday = travelStartDate.day() === 0;
  const isSaturday = travelStartDate.day() === 6;

  const travelStartDateToUnixtime = moment(
    `${travelStartDateunixTimeToDate} ${request.travelStartHour}`).unix();


  const travelEndDateToUnixtime = moment(
    `${travelEndDateunixTimeToDate} ${request.travelEndHour}`).unix();


  const calculateDiff = travelEndDateToUnixtime - travelStartDateToUnixtime;


  const currentDate = moment(new Date()).unix();


  const checkDateBiggerThanNow = travelStartDateToUnixtime >= currentDate || travelEndDateToUnixtime >= currentDate;


  const yurtDisiGeri = request.yurtDisiGeri;
  const yurtDisiIleri = request.yurtDisiIleri;
  const yurtIciGeri = request.yurtIciGeri;
  const yurtIciIleri = request.yurtIciIleri;
  const harcirahGrup = request.harcirahGrup;
  const pazarHarcirahGirilmesinGenel = request.pazarHarcirahGirilmesinGenel || false;

  const nowDate = moment(new Date().setHours(0, 0, 0, 0));
  let dataCheckAlert = false;


  if (request.type === DOMESTIC) {
    dataCheckAlert = false;
    dataCheckAlert = nowDate.diff(travelStartDate, 'days') > yurtIciGeri || travelEndDate.diff(nowDate, 'days') > yurtIciIleri;
  } else if (request.type === ABROAD) {
    dataCheckAlert = false;
    dataCheckAlert = nowDate.diff(travelStartDate, 'days') > yurtDisiGeri || travelEndDate.diff(nowDate, 'days') > yurtDisiIleri;
  }

  if (harcirahGrup) {
    if (harcirahGrup.length < 1) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiGroupInformationNotDefined",{index})}`
          : i18n.t("groupInformationNotDefined"),
        requestNumber: index,
      };
    }
  }

  if (dataCheckAlert) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiRequestCannotBeCreatedOutsideDateRange",{index})}`
        : i18n.t("requestCannotBeCreatedOutsideDateRange"),
      requestNumber: index,
    };
  }

  if (!request.travelStartDate) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseYourTravelStartDate",{index})}`
        : i18n.t("chooseYourTravelStartDate"),
      requestNumber: index,
    };
  }

  if (!request.travelStartHour) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseYourTravelStartTime",{index})}`
        : i18n.t("chooseYourTravelStartTime"),
      requestNumber: index,
    };
  }

  if (!request.travelEndDate) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseYourTravelEndDate",{index})}`
        : i18n.t("chooseYourTravelEndDate"),
      requestNumber: index,
    };
  }

  if (!request.travelEndHour) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseYourTravelEndTime",{index})}`
        : i18n.t("chooseYourTravelEndTime"),
      requestNumber: index,
    };
  }

  if (calculateDiff < 1800) {
    return {
      valid: false,
      message:
          parseInt(totalIndex) > 1 ? `${i18n.t("multiEndTimeMustBeMore",{index})}`
            : i18n.t("endTimeMustBeMore"),
      requestNumber: index,
    };
  }

  if (request.type === DOMESTIC) {
    if (differenceOfDates === 0) {
      if (isPublicDay) {
        return {
          valid: false,
          message:
              parseInt(totalIndex) > 1 ? `${i18n.t("multiCannotTravelExpenceOnPuclicHoliday",{index})}`
                : i18n.t("cannotTravelExpenceOnPuclicHoliday"),
          requestNumber: index,
        };
      }

      if (isSunday && pazarHarcirahGirilmesinGenel) {
        return {
          valid: false,
          message: parseInt(totalIndex) > 1 ? `${i18n.t("multiConnotTravelExpenceClaimOnSundays",{index})}`
            : i18n.t("connotTravelExpenceClaimOnSundays"),
          requestNumber: index,
        };
      }
    }


    if (!request.domestic.provinces.length) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseCitiesTraveled",{index})}`
          : i18n.t("chooseCitiesTraveled"),
        requestNumber: index,
      };
    }

    // 86400 is equal to 24 hour
    if (!isSaturday && request.nearBy && calculateDiff < 86400) {
      return {
        valid: false,
        message:
            parseInt(totalIndex) > 1 ? `${i18n.t("multiConnotBeClaimedForDailyTripsInNearbyProvices",{index})}`
              : i18n.t("connotBeClaimedForDailyTripsInNearbyProvices"),
        requestNumber: index,
      };
    }

    if (!request.harcirahIleriyeDonukKontrolVarMi) {
      if (checkDateBiggerThanNow) {
        return {
          valid: false,
          message: parseInt(totalIndex) > 1 ? `${i18n.t("multiForwadDateddomesticAllowanceCannotBe",{index})}`
            : i18n.t("forwadDateddomesticAllowanceCannotBe"),
          requestNumber: index,
        };
      }
    }

    if (request.harcirahMesaiSaatleri && differenceOfDates === 0 && !isSaturday) {
      const workingTime = request.harcirahMesaiSaatleri.split('-');
      const workBeginTime = workingTime[0];
      const workEndTime = workingTime[1];
      const workBeginDateToUnixTime = moment(`${travelStartDateunixTimeToDate} ${workBeginTime}`).unix();
      const workEndDateToUnixTime = moment(`${travelStartDateunixTimeToDate} ${workEndTime}`).unix();

      if (workBeginDateToUnixTime <= travelStartDateToUnixtime && workEndDateToUnixTime >= travelEndDateToUnixtime) {
        return {
          valid: false,
          message: parseInt(totalIndex) > 1 ? `${i18n.t("multiNotPossibleEnterTravelExpenseDuringWorkingHours",{index})}`
            : i18n.t("notPossibleEnterTravelExpenseDuringWorkingHours"),
          requestNumber: index,
        };
      }
    }
  }

  if (request.type === ABROAD && request.abroad) {
    if (!request.abroad.region) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiSelectCountyOfTravel",{index})}`
          : i18n.t("selectCountyOfTravel"),
        requestNumber: index,
      };
    }

    if (!request.abroad.workStartDate) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseJobStartDate",{index})}`
          : i18n.t("chooseJobStartDate"),
        requestNumber: index,
      };
    }

    if (!request.abroad.workStartHour) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseJobStarTime",{index})}`
          : i18n.t("chooseJobStarTime"),
        requestNumber: index,
      };
    }


    if (!request.abroad.passportNo && request.abroad.isPasaportRequired) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiEnterPassportNumber",{index})}` : i18n.t("enterPassportNumber"),
        requestNumber: index,
      };
    }
    if (request.abroad.visa.value === '' && request.abroad.isPasaportRequired) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("chooseViseStatus",{index})}`
          : i18n.t("chooseViseStatus"),
        requestNumber: index,
      };
    }
  }

  if (request.individualAccommodation) {
    let howManyDays = travelEndDateToUnixtime - travelStartDateToUnixtime;

    howManyDays = parseInt(howManyDays / 86400);


    if (request.individualAccommodationDays <= 0) {
      return {
        valid: false,
        message: parseInt(totalIndex) > 1 ? `${i18n.t("multiSpecifyTheIndividualStayDay",{index})}`
          : i18n.t("specifyTheIndividualStayDay"),
        requestNumber: index,
      };
    }

    if (howManyDays < request.individualAccommodationDays) {
      return {
        valid: false,
        message:
            parseInt(totalIndex) > 1
              ? `${i18n.t("multiConnotEnterIndividualAccommodationMoreThan",{index})}`
              : i18n.t("connotEnterIndividualAccommodationMoreThan"),
        requestNumber: index,
      };
    }
  }

  if (!request.travelReasons.length) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiChooseReasonForTravel",{index})}`
        : i18n.t("chooseReasonForTravel"),
      requestNumber: index,
    };
  }

  if (!request.description) {
    return {
      valid: false,
      message: parseInt(totalIndex) > 1 ? `${i18n.t("multiEnterTripDescription",{index})}`
        : i18n.t("enterTripDescription"),
      requestNumber: index,
    };
  }

  return withNamespaces()({ valid: true, message: null, requestNumber: index });
}



// WEBPACK FOOTER //
// ./src/helpers/RequestValidator.js